'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import { buildCollectionHref } from '@/src/utils/holidays'

import HolidayBreadcrumbs from './holidayBreadcrumbs'

interface HolidayBreadcrumbsWrapperProps {
    /** Omitted on the collection page itself. */
    collection?: { slug: string; label: string }
    /** The current page. Rendered without a link. */
    currentLabel: string
}

const HolidayBreadcrumbsWrapper: React.FC<HolidayBreadcrumbsWrapperProps> = ({ collection, currentLabel }) => {
    const t = useTranslations('holidaysPage')

    // Home > collection > current. The bare "Holidays" index adds a crumb without adding
    // orientation, so the trail goes straight from home to the collection the package sits in.
    const items: Array<{ label: string; href?: string }> = [{ label: t('breadcrumbHome'), href: '/' }]

    if (collection) {
        items.push({ label: collection.label, href: buildCollectionHref(collection.slug) })
    }

    items.push({ label: currentLabel })

    return <HolidayBreadcrumbs items={items} />
}

export { HolidayBreadcrumbsWrapper }
export default HolidayBreadcrumbsWrapper
